const STRING_CONSTANTS = {
  TOKEN_PARAM_KEY: "data",
  COOKIE_NAME: "pwaToken",
  AVAILABLE_OFFERS: "Available Offers",
  REEDEMED_OFFERS: "Reedemed Offers",
  EMPTY: "Oops... It's empty in here!",
  NO_OFFERS_FOUND: "No Offers available for you currently",
  FILTER: "Filter",
  ONLY_FOR_YOU: "Only for You",
  GENERIC_OFFER: "Generic Offer",
  OFFER_TYPE: " Based",
  OFFER_CODE: "Offer Code: ",
  REFER_A_FRIEND: "REFER A FRIEND",
  INVITE: "Invite",
  INVITE_FRIENDS: "Invite Friends",
  REFERED_FRIEND: "REFERED FRIEND",
  LOYALTY_POINTS: "Active Points",
  LOYALTY_LEVEL: "Loyalty Tier",
  POINTS_EXPIRED: "Points expiring by",
  DAYS: "Days",
  BILL_ID: "Bill No:",
  EMAIL: "Email:  ",
  PHONE_NUMBER: "Phone Number:  ",
  VOUCHER_NO: "Voucher No: ",
  VOUVHER_PIN: "Voucher Pin",
  VALID_TILL: "Valid Till: ",
  ACTIVE: "Active",
  NOT_AVAILABLE: "Not Available",
  BRAND_LOGO: "Brand Logo",
  ACTIVATE: "Activate",
  SUBMIT: "Submit",
  OK: "OK",
  APOLOGY: "Apologies! ",
  CONTENT: "Something went wrong!",
  AWESOME: "Awesome!",
  CONTENT_1: "You have Activated 1 voucher",
  CONTENT_2:
    "Show this when you are doing next purchase and enjoy shopping benefits",
  SCHEME: "Scheme",
  SCHEMES: "Schemes",
  SCHEME_PROMO_TITLE: "Save Every Month, Shop Much More",
  SCHEME_PROMO_SUBTITLE:
    "Save every month and receive the retailer's contribution free as a maturity reward.",
  JOIN: "Join",
  JOIN_SCHEME: "Join Scheme",
  SELECT_STORE: "Select your store",
  STORE_HELP: "Choose the store where you will use this scheme.",
  STORE_OPTIONS_LOAD_FAILED: "We could not load the stores. Please try again.",
  NO_STORES_AVAILABLE: "No stores are available to join right now.",
  RETRY: "Retry",
  YOUR_SCHEMES: "Your Schemes",
  NO_SCHEMES_FOUND: "No schemes here yet. Join a scheme to start saving.",
  NO_SCHEMES_TO_JOIN: "No schemes are available to join right now.",
  SCHEME_NOT_FOUND: "We could not find this scheme.",
  SCHEME_JOINED: "You have joined the scheme",
  MONTHLY_DEPOSIT: "Monthly Deposit: ",
  ACCUMULATED: "Accumulated",
  NEXT_DUE: "Next Due:",
  AWAITING_ACTIVATION_PAYMENT: "Awaiting activation payment",
  ALL_INSTALMENTS_RECORDED: "All instalments recorded",
  CANCELLED_ON: "Cancelled on",
  MATURED_ON: "Matured on",
  CANCELLED_ON_LABEL: "Cancelled On",
  MATURED_ON_LABEL: "Matured On",
  EST_VALUE: "Est. Value",
  START_DATE: "Start Date",
  MATURITY_DATE: "Maturity Date",
  PAID_INSTALMENTS: "Paid Instalments",
  TOTAL_PAID: "Total Paid",
  CUSTOMER_CONTRIBUTION: "Customer contribution",
  INSTALMENTS: "Instalments",
  PAID_ON: "Paid on",
  DUE_ON: "Due on",
  DUE_TODAY: "Due today",
  PAY_BY: "Pay by",
  IN_GRACE_PERIOD: "In grace period",
  GRACE_PERIOD_ACTIVE: "Grace period — pay by",
  GRACE_PERIOD_ELAPSED: "Grace period elapsed",
  SCHEME_CANCELLED_NOTE: "Closed with the scheme",
  PAID: "Paid",
  MISSED: "Missed",
  MISSED_LABEL: "missed",
  WALLET_VALUE: "Wallet Value",
  CONTRIBUTION_NOT_APPLICABLE:
    "The retailer contribution does not apply to a cancelled scheme.",
  RETAILER_CONTRIBUTION: "Retailer contribution on completion",
  CHOOSE_MONTHLY_AMOUNT: "Choose Monthly Amount",
  CHOOSE_AMOUNT_HELP:
    "Select or enter a custom amount. You pay this every month for",
  CUSTOM: "Custom",
  ENTER_AMOUNT: "Enter amount",
  MATURES: "matures",
  MIN: "Min",
  MULTIPLES_OF: "In multiples of",
  MONTHLY_INSTALMENT: "Monthly instalment",
  DURATION: "Duration",
  YOU_PAY: "You pay",
  CONTRIBUTES: "contributes",
  TOTAL_WALLET_VALUE: "Total wallet value",
  I_AGREE_TO_THE: "I agree to the",
  TERMS_AND_CONDITIONS: "Terms & Conditions",
  AGREE_TERMS: "Agree to the terms and conditions",
  BACK: "Back",
  PAY: "Pay",
  PAYMENT_SUCCESSFUL: "Payment successful. Your instalment is marked paid.",
  PAYMENT_PROCESSING:
    "Your payment is being processed. This instalment will update once it is confirmed.",
  PAYMENT_REFUNDED:
    "This payment could not be applied to your instalment. The amount will be refunded to your original payment method.",
  PAYMENT_NOT_COMPLETED:
    "Payment not completed. If money was debited, this page will update shortly.",
  PAYMENT_CONFIRMING: "Confirming your payment…",
  PAYMENT_UNCONFIRMED:
    "We couldn't confirm your payment yet. If money was debited, this page will update shortly.",
  PAYMENT_FAILED: "Payment failed. You can try again.",
  PAYMENT_START_FAILED: "Could not start the payment. Please try again.",
  PAYMENT_CONFIRM_FAILED:
    "Could not confirm the payment right now. If money was debited, this instalment will update shortly.",
  PAYMENT_WINDOW_FAILED: "Could not open the payment window. Please try again.",
};

export default STRING_CONSTANTS;
